import { Component, OnInit, ViewChild, Input, OnChanges, ElementRef, Renderer2, EventEmitter, Output, ChangeDetectorRef, OnDestroy, SimpleChange, SimpleChanges } from '@angular/core';
import { DataBindingDirective } from '@progress/kendo-angular-grid';
import { SVGIcon, fileExcelIcon, pencilIcon, trashIcon, downloadIcon, mapMarkerIcon, checkIcon, envelopeIcon, plusIcon, shareIcon, eyeIcon, hyperlinkOpenIcon, sparklesIcon, gearIcon } from '@progress/kendo-svg-icons';
import { process, State, FilterDescriptor } from '@progress/kendo-data-query';
import { GridModule } from '@progress/kendo-angular-grid';
import { ChartsModule } from '@progress/kendo-angular-charts';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { ExcelExportModule, ExcelExportComponent } from "@progress/kendo-angular-excel-export";
import { ButtonsModule } from "@progress/kendo-angular-buttons";
import { MatDialogModule, MatDialog } from '@angular/material/dialog';
import { GridService } from 'app/services/grid.service';
import { Router } from '@angular/router';
import { MatToolbarModule } from '@angular/material/toolbar';
import { DropDownsModule } from "@progress/kendo-angular-dropdowns";
import { TranslocoPipe } from '@ngneat/transloco';
import { IntlService } from '@progress/kendo-angular-intl';
import { CheckBoxModule } from '@progress/kendo-angular-inputs';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { MapModule } from '@progress/kendo-angular-map';
import { SharedModule } from '../../modules/shared.module';
import { AuthService } from '../../core/auth/auth.service';
import { DrakeSharedService } from '../../services/drake-shared.service';
import { DrakeCustomScriptsService } from 'app/services/drake-custom-scripts.service';
import { ConfirmCancelDialogComponent } from '../drake-confirm-cancel-dialog/drake-confirm-cancel-dialog.component';
import { QuickAddService } from 'app/services/quick-add.service';
import { Subscription } from 'rxjs';
import { IconsModule } from '@progress/kendo-angular-icons';
import { MatIconModule } from '@angular/material/icon';
import { DrakeViewConfig } from 'app/models/permissions';
import { environment } from 'environments/environment';
import { DrakeGridCustomTemplateComponent } from '../drake-grid-custom-template/drake-grid-custom-template.component';

interface Option {
  value: string;
  text: string;
}

@Component({
  selector: 'app-drake-grid',
  standalone: true,
  imports: [
    CommonModule,
    HttpClientModule,
    GridModule,
    ChartsModule,
    InputsModule,
    ButtonsModule,
    ExcelExportModule,
    MatToolbarModule,
    MatDialogModule,
    DropDownsModule,
    CheckBoxModule,
    MapModule,
    TranslocoPipe,
    SharedModule,
    MatIconModule,
    IconsModule,
    DrakeGridCustomTemplateComponent
  ],
  providers: [TranslocoPipe],
  templateUrl: './drake-grid.component.html',
  styleUrls: ['./drake-grid.component.scss']
})
export class DrakeGridComponent implements OnInit, OnChanges, OnDestroy {
  @ViewChild(DataBindingDirective) dataBinding: DataBindingDirective;
  @ViewChild(ExcelExportComponent) excelExportComponent: ExcelExportComponent;
  public gridData: any[] = [];
  public exportGridData: any[] = [];
  public trustData: any[] = [];
  public gridView: any[] = [];
  public gridColumns: any[] = [];
  public mySelection: string[] = [];
  public excelSVG: SVGIcon = fileExcelIcon;
  public newItemSVG: SVGIcon = plusIcon;
  public editIcon: string = "pencil";
  public viewIcon: string = "eye";
  public deleteIcon: string = "trash";
  public downloadSVG: SVGIcon = downloadIcon;
  public markerSVG: SVGIcon = mapMarkerIcon;
  public checkSVG: SVGIcon = checkIcon;
  public shareIconSVG: SVGIcon = shareIcon;
  public editSVG: SVGIcon = pencilIcon;
  public deleteSVG: SVGIcon = trashIcon;
  public viewSVG: SVGIcon = eyeIcon;
  public aiSVG: SVGIcon = sparklesIcon;
  public linkSVG: SVGIcon = hyperlinkOpenIcon;
  public emailSVG: SVGIcon = envelopeIcon;
  public gearIcon: SVGIcon = gearIcon;

  public isDownloading: boolean = false;

  @Output() public valueChanged: EventEmitter<any> = new EventEmitter<any>();
  public locationFilterValue: string = "";

  public viewConfig: DrakeViewConfig = { canDelete: false, canEdit: false, canExport: false, canInsert: false, canView: false, canAi: false, progressiveLoading: 0, exportFilename: null };
  public recordId: string = '';


  @Input() public viewCode: string = '';
  @Input() public filter: string = '{}';
  @Input() public template: string = null;
  @Input() public sort: string = '{}';
  @Input() public commandName: string = 'READ';
  @Input() public scope: string = '';
  @Input() public isSubGrid: boolean = false;
  @Input() public linkToNewItem: string = '';
  @Input() public oldUrlGrid: string = '';



  state: State = {
    skip: 0,
    take: Infinity,
    filter: {
      logic: 'and',
      filters: []
    }
  };


  // location
  public location: { lat: number, lon: number, description: string } = { lat: 0, lon: 0, description: '' };
  public searchResults: any[] = [];
  public searchQuery: string = '';

  //Mask
  public mask: string = "(999) 000-00-00-00";
  public dropdownOptions: { [key: string]: Option[] } = {};
  public filteredDropdownOptions: { [key: string]: Option[] } = {};

  quickAddDataSubscription: Subscription;
  exportSubjectSubscription: Subscription;
  currentQuickAddData: any;
  subscription: any;
  elRef: any;

  constructor(
    private gridService: GridService,
    public dialog: MatDialog,
    public intl: IntlService,
    public renderer: Renderer2,
    private sanitizer: DomSanitizer,
    private router: Router,
    private authService: AuthService,
    private drakeSharedService: DrakeSharedService,
    private drakeScripts: DrakeCustomScriptsService,
    private cdr: ChangeDetectorRef,
    private quickAddService: QuickAddService,
    private translocoPipe: TranslocoPipe
  ) { }


  ngOnInit(): void {

    this.recordId = window.location.href.split("/f/")[1];
    this.loadGridConfiguration();
    console.log("Scope, ViewCode, Filter", this.scope, this.viewCode, this.filter);
  }

  ngOnDestroy(): void {
    if (this.quickAddDataSubscription) {
      this.quickAddDataSubscription.unsubscribe();
    }
    if (this.exportSubjectSubscription)
      this.exportSubjectSubscription.unsubscribe();
  }


  height(): string | number {
    return window.innerHeight - 70;
  }

  ngOnChanges(changes: SimpleChanges): void {
    console.log('changes', changes)
    if (this.scope) {
      this.loadGridConfiguration();
    }
    //console.log('height', this.elRef.nativeElement.parentElement.style.height)

  }

  getMatrixLength(value: any): number {
    //return Array.isArray(value) ? value.length : 0;
    return value.split(",").length | 0;
  }

  buttonAction(dataItem: any, column: any): void {
    eval(column.fieldFormula)
  }


  loadGridConfiguration(): void {

    if (!this.viewCode || !this.scope || !this.commandName) {
      return;
    }
    if (this.quickAddDataSubscription)
      this.quickAddDataSubscription.unsubscribe();
    if (this.exportSubjectSubscription)
      this.exportSubjectSubscription.unsubscribe();

    this.quickAddDataSubscription = this.quickAddService.quickAddDataSubject$.subscribe((scope: string) => {
      if (scope == this.scope)
        this.loadGridData();
    })
    this.exportSubjectSubscription = this.drakeSharedService.exportSubject.subscribe(() => {
      this.exportToExcel();
    });


    this.gridService.getScopeView(this.viewCode).subscribe(
      (viewConfig: any) => {
        this.viewConfig = {
          canInsert: viewConfig.canInsert,
          canEdit: viewConfig.canEdit,
          canDelete: viewConfig.canDelete,
          canView: viewConfig.canEdit,
          canExport: viewConfig.canExport,
          canAi: viewConfig.canAi,
          progressiveLoading: viewConfig.progressiveLoading,
          exportFilename: viewConfig.exportFilename
        };
        this.drakeSharedService.editableSubject.next(this.viewConfig);
        this.gridColumns = viewConfig.fields.map((field: any) => {
          let columnDef: any = {
            field: field.columnName,
            title: field.header,
            width: field.size,
            hidden: !field.visible,
            filter: this.getFilterType(field.fieldType, field.fieldControlType),
            sortable: field.sort,
            format: field.format ? `{0:${field.format}}` : undefined,
            cssClass: field.cssClass,
            template: field.template,
            fieldType: field.fieldType,
            fieldControlType: field.fieldControlType,
            fieldControlFormat: field.fieldControlFormat,
            order: field.order,
            group: field.group,
            fieldFormula: field.fieldFormula,
            fieldDescription: field.fieldDescription,
          };

          return columnDef;
        });

        this.loadGridData();
      },
      (error) => {
        console.error('Errore durante il caricamento della configurazione della griglia', error);
      }
    );
  }

  handleFilterDrp(value: string, field: string) {
    // Se il valore è vuoto, ripristina i dati completi
    if (!value) {
      this.filteredDropdownOptions[field] = this.dropdownOptions[field];
      return;
    }

    // Filtra i dati in base al testo inserito (case-insensitive)
    this.filteredDropdownOptions[field] = this.dropdownOptions[field].filter(
      (s) => s.text.toLowerCase().indexOf(value.toLowerCase()) !== -1
    );

  }


  getFilterType(fieldType: string, fieldControlType: string): string {
    if (fieldControlType === 'DROPDOWNLIST') {
      return 'dropdownlist';
    }
    if (fieldControlType === 'HTML') {
      return 'html';
    }
    if (fieldControlType === 'COLORPICKER') {
      return 'colorPicker';
    }
    if (fieldControlType === 'CODEEDITOR') {
      return 'codeEditor';
    }

    switch (fieldType) {
      case 'TEXTBOX':
      case 'STRING':
        return 'text';
      case 'BOOLEAN':
      case 'BOOL':
        return 'boolean';
      case 'NUMBERIC':
      case 'DECIMAL':
      case 'INT':
        return 'numeric';
      case 'DATEPICKER':
      case 'DATETIME':
        return 'date';
      case 'LOCATION':
        return 'location';
      case 'ARRAY':
        return 'array';
      default:
        return 'text';
    }
  }

  loadGridDataFull(): void {

    this.gridView = [];
    const requestData = {
      ViewCode: this.viewCode,
      Filter: this.filter,
      Sort: this.sort,
      Page: 0,
      PageSize: 0,
      Language: "",
      Cache: false,
      ExtraData: {}
    };
    this.gridService.getScopeData(this.scope, this.commandName, requestData).subscribe(
      (response: any) => {

        this.gridData = response.data.map((originalItem: any) => {

          const item = {} as any;

          for (let k of Object.keys(originalItem)) {
            const newKey = k.includes('$') ? k.split('$')[1] : k;
            item[newKey] = originalItem[k];
          }

          for (let column of this.gridColumns) {



            let key = column.field;
            let fieldControlType = column.fieldControlType;

            if (Array.isArray(item[key]) && fieldControlType != 'MATRIX') {
              // Concatenate array elements into a single string
              item[key] = item[key].join(', ');
            }

            if (item[key] === null || item[key] === undefined) {
              item[key] = '';
            } else if (fieldControlType === 'DATETIME') {
              item[key] = new Date(item[key]);
            }
            else if (fieldControlType === 'MATRIX') {
              item[key] = item[key].length + " " + this.translocoPipe.transform("grid.matrix.record");
            }
            else if (fieldControlType === 'FILE') {
              item[key] = {
                dataUrl: item[key]?.dataUrl ?? '',
                fileName: item[key]?.fileName ?? '',
                id: item[key]?.id ?? ''
              };
            } else if (fieldControlType === 'COLORPICKER') {
              item[key] = {
                text: item[key] ?? '',
                value: item[key] ?? ''
              };
            } else if (fieldControlType === 'FULL') {
              item[key] = {
                description: String(item[key]?.description) ?? '',
                lat: item[key]?.lat ?? 0,
                lon: item[key]?.lon ?? 0
              };
            } else if (fieldControlType === 'CODEEDITOR') {
              if (typeof item[key] === 'object') {
                item[key] = JSON.stringify(item[key], null, 2);
              }
            } else if (fieldControlType === 'RATING') {
              item[key] = item[key] ?? 0
            }


          }
          return item;
        });

        this.gridView = [...this.gridData];
        this.exportGridData = this.gridData.slice().map(d => {
          var item = JSON.parse(JSON.stringify(d));
          for (let column of this.gridColumns) {
            let key = column.field;
            let fieldControlType = column.fieldControlType;

            if (fieldControlType === 'DATETIME') {
              if (typeof item[key].getMonth == 'function')
                item[key] = item[key].toLocaleString();
            }
            else if (fieldControlType === 'FILE') {
              if (item[key].fileName)
                item[key] = item[key].fileName;
            } else if (fieldControlType === 'COLORPICKER') {
              if (item[key].text)
                item[key] = item[key].text;
              else if (item[key].value)
                item[key] = item[key].value;
            } else if (fieldControlType === 'FULL') {
              if (item[key].lat && item[key].lon)
                item[key] = item[key].lat.toString() + ' - ' + item[key].lon.toString();

            } else if (fieldControlType === 'DROPDOWNLIST') {
              item[key] = item[key]?.text
            }


          }

          return item;

        });

        console.log(this.exportGridData);
        this.isDownloading = false;
        this.populateDropdownOptions();
      },
      (error) => {
        console.error('Error loading grid data', error);
      }
    );
  }


  loadGridData(): void {
    this.isDownloading = true;
    this.gridView = [];
    this.gridData = [];
    this.exportGridData = []; // Inizializziamo anche questo

    if (this.viewConfig.progressiveLoading > 0) {
      const pageSize = this.viewConfig.progressiveLoading;
      this.fetchNextPage(0, pageSize);
    }
    else
      this.loadGridDataFull();
  }

  private fetchNextPage(pageIndex: number, pageSize: number): void {
    const requestData = {
      ViewCode: this.viewCode,
      Filter: this.filter,
      Sort: this.sort,
      Page: pageIndex,
      PageSize: pageSize,
      Language: "",
      Cache: false,
      ExtraData: {}
    };

    this.gridService.getScopeData(this.scope, this.commandName, requestData).subscribe(
      (response: any) => {
        const rawBatch = response.data || [];

        if (rawBatch.length > 0) {
          // --- TRASFORMAZIONE PROGRESSIVA ---

          // 1. Mappatura per la visualizzazione in Griglia
          const processedBatch = rawBatch.map((originalItem: any) => {
            const item = {} as any;
            for (let k of Object.keys(originalItem)) {
              const newKey = k.includes('$') ? k.split('$')[1] : k;
              item[newKey] = originalItem[k];
            }

            for (let column of this.gridColumns) {
              let key = column.field;
              let fieldControlType = column.fieldControlType;

              if (Array.isArray(item[key]) && fieldControlType != 'MATRIX') {
                item[key] = item[key].join(', ');
              }

              if (item[key] === null || item[key] === undefined) {
                item[key] = '';
              } else if (fieldControlType === 'DATETIME') {
                item[key] = new Date(item[key]);
              } else if (fieldControlType === 'MATRIX') {
                item[key] = item[key].length + " " + this.translocoPipe.transform("grid.matrix.record");
              } else if (fieldControlType === 'FILE') {
                item[key] = {
                  dataUrl: item[key]?.dataUrl ?? '',
                  fileName: item[key]?.fileName ?? '',
                  id: item[key]?.id ?? ''
                };
              } else if (fieldControlType === 'COLORPICKER') {
                item[key] = { text: item[key] ?? '', value: item[key] ?? '' };
              } else if (fieldControlType === 'FULL') {
                item[key] = {
                  description: String(item[key]?.description) ?? '',
                  lat: item[key]?.lat ?? 0,
                  lon: item[key]?.lon ?? 0
                };
              } else if (fieldControlType === 'CODEEDITOR') {
                if (typeof item[key] === 'object') item[key] = JSON.stringify(item[key], null, 2);
              } else if (fieldControlType === 'RATING') {
                item[key] = item[key] ?? 0;
              }
            }
            return item;
          });

          // 2. Mappatura per l'Export (basata sui dati appena processati)
          const exportBatch = processedBatch.map(d => {
            const item = JSON.parse(JSON.stringify(d)); // Deep copy del record processato
            for (let column of this.gridColumns) {
              let key = column.field;
              let fieldControlType = column.fieldControlType;

              if (fieldControlType === 'DATETIME' && typeof item[key].getMonth == 'function') {
                item[key] = item[key].toLocaleString();
              } else if (fieldControlType === 'FILE' && item[key].fileName) {
                item[key] = item[key].fileName;
              } else if (fieldControlType === 'COLORPICKER') {
                item[key] = item[key].text || item[key].value;
              } else if (fieldControlType === 'FULL' && item[key].lat && item[key].lon) {
                item[key] = `${item[key].lat} - ${item[key].lon}`;
              } else if (fieldControlType === 'DROPDOWNLIST') {
                item[key] = item[key]?.text;
              }
            }
            return item;
          });

          // 3. Aggiornamento degli array principali
          this.gridData = [...this.gridData, ...processedBatch];
          this.exportGridData = [...this.exportGridData, ...exportBatch];

          // Aggiorna la vista in tempo reale (opzionale, utile se vuoi mostrare i record mentre carica)
          this.gridView = [...this.gridData];

          // 4. Controllo ricorsivo
          if (rawBatch.length === pageSize) {
            this.fetchNextPage(pageIndex + 1, pageSize);
          } else {
            this.finalizeData();
          }
        } else {
          this.finalizeData();
        }
      },
      (error) => console.error('Error loading batch', pageIndex, error)
    );
  }

  private finalizeData(): void {
    this.isDownloading = false;
    this.populateDropdownOptions();
    console.log('Caricamento e trasformazione completati.', this.gridData.length, 'record totali.');
  }

  isEditable(item: any): boolean {
    if (item._editable)
      return true;
    else if (!item._editable)
      return false;

    return true;
  }

  onChange() {
    const locationField = this.gridColumns.find(col => col.fieldControlType === 'FULL')?.field || 'location';
    const updatedData = {
      [locationField]: {
        lat: this.location.lat,
        lon: this.location.lon,
        description: this.location.description
      }
    };
    this.valueChanged.emit(updatedData);
  }


  onSearch(searchQuery: string) {
    this.searchQuery = searchQuery;
    if (this.searchQuery.trim() === '') {
      this.clearLocationFilter();
      return;
    }
    const locationColumn = this.gridColumns.find(col => col.fieldControlType === 'FULL');
    const locationField = locationColumn ? locationColumn.field : 'location';

    this.gridView = this.gridData.filter((item: any) => {
      const location = item[locationField];
      return location && location.description && location.description.toLowerCase().includes(this.searchQuery.toLowerCase());
    });
  }


  clearLocationFilter() {
    this.location = { lat: 0, lon: 0, description: '' };
    this.searchResults = [];
    this.gridView = this.gridData;
  }

  isDateField(fieldName: string): boolean {
    return this.gridColumns.some(column => column.field === fieldName && column.fieldType === 'DATETIME');
  }

  formatDate(value: string): string {
    if (!value) return '';
    const date = new Date(value);
    return `${date.getDate().toString().padStart(2, '0')}/${(date.getMonth() + 1).toString().padStart(2, '0')}/${date.getFullYear()}`;
  }

  populateDropdownOptions(): void {
    this.gridColumns.forEach(column => {
      const options: Option[] = [];
      const uniqueValues = new Set();
      let hasEmptyOption = false;

      this.gridData.forEach(item => {
        if (item[column.field]) {
          // Verifica se value e text sono undefined o null e assegna ''
          const value = item[column.field].value ?? '';
          const text = item[column.field].text ?? '';

          if (value === '' && text === '') {
            hasEmptyOption = true;
          }
          if (!uniqueValues.has(value)) {
            uniqueValues.add(value);
            options.push({ value, text });
          }
        }
      });

      if (!hasEmptyOption) {
        options.unshift({ text: '', value: '' });
      }

      this.dropdownOptions[column.field] = options;
      this.filteredDropdownOptions[column.field] = JSON.parse(JSON.stringify(options));
    });
  }


  private flattenData(data: any[]): any[] {
    return data.map(item => {
      const flatItem = { ...item };
      for (let key in item) {
        if (item[key] && item[key].value !== undefined) {
          flatItem[key] = item[key].value;
        } else if (this.isDateField(key)) {
          flatItem[key] = item[key];
        }
      }
      return flatItem;
    });
  }

  private mapFilteredData(filteredData: any[]): any[] {
    return filteredData.map(filteredItem => {
      const originalItem = this.gridData.find(item => item._id === filteredItem._id);
      return originalItem ? originalItem : filteredItem;
    });
  }

  public onFilterChange(value: any, column: any): void {
    const filters = this.state.filter.filters as FilterDescriptor[];
    const existingFilterIndex = filters.findIndex(f => f.field === column.field);

    if (existingFilterIndex >= 0) {
      if (value) {
        filters[existingFilterIndex].value = value;
      } else {
        filters.splice(existingFilterIndex, 1);
      }
    } else if (value) {
      filters.push({ field: column.field, operator: 'eq', value: value });
    }

    this.state = {
      ...this.state,
      filter: {
        ...this.state.filter,
        filters: filters
      }
    };

    const flattenedData = this.flattenData(this.gridData);
    const filteredData = process(flattenedData, this.state).data;
    this.gridView = this.mapFilteredData(filteredData);
  }

  getFormattedDate(date: string): string {
    return this.formatDate(date);
  }

  getFormattedValue(value: number | string | null | undefined): string {
    if (value === "" || value == null) {
      return "";
    }

    const num = Number(value);

    if (isNaN(num)) {
      return "";
    }

    return num.toFixed(2);
  }


  editActivity(dataItem: any): void {

    this.drakeSharedService.editItem(this.scope, dataItem._id, dataItem._editable);
    /*if (dataItem._editable) {
      this.drakeSharedService.editItem(this.scope, dataItem._id);
    }
    else
      this.drakeSharedService.editItem(this.scope, dataItem._id, false);*/

    //this.cdr.detectChanges();

  }

  aiAnalysis(dataItem: any): void {
    this.router.navigate(['/ai-analysis'], { queryParams: { scope: this.scope, recordId: dataItem._id } })
  }

  deleteActivity(dataItem: any): void {
    const dialogRef = this.dialog.open(ConfirmCancelDialogComponent, {
      width: '400px',
      data: { entityType: 'activity', message: this.translocoPipe.transform('modal.matrix.text'), title: this.translocoPipe.transform('modal.matrix.title') }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        const requestData = {

          _id: dataItem._id

        };

        this.gridService.deleteScopeData(this.scope, 'DELETE', requestData).subscribe(
          () => {
            this.loadGridData();
            var notification = this.translocoPipe.transform("notification.success.grid.delete");
            this.drakeSharedService.showTemporaryNotification(notification, 'success');

          },
          error => {
            console.error('Error deleting activity:', error);
            var notification = this.translocoPipe.transform("notification.error.grid.delete");
            this.drakeSharedService.showTemporaryNotification(notification, 'error');
          }
        );
      }
    });
  }

  cleanFormat(format: string) {
    return JSON.parse(format.substring(format.indexOf('{', 1), format.lastIndexOf('}')));
  }

  goTo(url: string, column: any) {
    if (!column.format)
      return false;

    var format = this.cleanFormat(column.format);
    if (format.component)
      this.router.navigateByUrl(url + "/t/" + format.component);
    else
      this.router.navigateByUrl(url);

  }

  goToUrl(url: string) {
    window.open(url);
  }

  canNavigate(column: any) {
    if (!column.format)
      return false;

    var format = this.cleanFormat(column.format);
    return !!format.navigate;
  }

  exportToExcel(): void {
    debugger;
    this.excelExportComponent.fileName = this.getExportFileName();
    this.excelExportComponent.save();
  }

  newItem(): void {

    if (this.linkToNewItem != '') {
      this.drakeSharedService.navigateWithBreadCrumb([this.linkToNewItem]);
    }

  }
  navigateToAdvancedSearch(): void {
    this.router.navigate(['/d', this.viewCode, 'filter']);
  }
  getFileName(dataItem: any, field: string): string {
    return dataItem[field]?.fileName || 'No file available';
  }

  getFileUrl(dataItem: any, field: string): string {
    return dataItem[field]?.dataUrl || '#';
  }

  getPrivateFileUrl(dataItem: any, field: string): string { //TODO
    //debugger;
    var url = environment.apiUrl + 'DrakeData/GetPrivateFileByPath/' + encodeURIComponent(dataItem[field]) || '#';
    return url;
  }

  // Metodi per la visualizzazione del contenuto HTML e del colore
  sanitizeHtml(html: string): string {
    return html; // Puoi aggiungere qui logiche di sanitizzazione se necessario
  }
  getExportFileName() {

    var date = new Date();
    let fileName = `${this.viewConfig.exportFilename || this.scope}_${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')}-${date.getHours().toString().padStart(2, '0')}-${date.getMinutes().toString().padStart(2, '0')}.xlsx`;

    return fileName;

  }

  getColorSquare(color: string): SafeHtml {
    if (!color) {
      return this.sanitizer.bypassSecurityTrustHtml('');
    }
    return this.sanitizer.bypassSecurityTrustHtml(
      `<span style="width: 20px; height: 20px; background-color: ${color}; border: 1px solid #000; display: inline-block; margin-right: 5px;"></span>`
    );
  }

  formatMasked(value: string): string {
    let formattedValue = this.mask;
    let dataIndex = 0;

    for (let i = 0; i < formattedValue.length; i++) {
      if (formattedValue[i] === '9' || formattedValue[i] === '0') {
        if (dataIndex < value.length) {
          formattedValue = formattedValue.substring(0, i) + value[dataIndex] + formattedValue.substring(i + 1);
          dataIndex++;
        } else {
          formattedValue = formattedValue.substring(0, i) + ' ' + formattedValue.substring(i + 1);
        }
      }
    }
    return formattedValue;
  }

  public getButtonColumnWidth = () => 60 * ((+(this.viewConfig.canEdit || this.viewConfig.canView)) + (+this.viewConfig.canDelete) + this.gridColumns.filter(c => c.fieldControlType === 'BUTTON').length)
}

